import React from 'react'
import styled from 'styled-components'
import isArray from 'lodash/isArray'

import { SectionSubtitle } from './shared'

const PriceList = styled.ul`
  color: #999;
  margin: 0;
  padding: 0;

  list-style: none;

  li {
    margin-bottom: 16px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  em {
    color: #333;
    font-style: normal;
  }
`

export default ({ listing }) => {
  return (
    <PriceList>
      {Object.keys(listing.pricing).map((label, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <li key={index}>
          {label}&nbsp;
          {isArray(listing.pricing[label]) ? (
            listing.pricing[label].map((p) => (
              <em>
                <br />
                {p}
              </em>
            ))
          ) : (
            <em>{listing.pricing[label]}</em>
          )}
        </li>
      ))}
    </PriceList>
  )
}
